// extracted by mini-css-extract-plugin
export default {"date":"published-state_date__OOXoJ","text":"published-state_text__F-hlw"};